import { DataStructure } from '../../domain/structure/DataStructureDomains';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';

export type StructActions = 'CHANGE_DATA_STRUCT' | 'CHANGE_STRUCT_IS_UPDATE' | 'CLEAR_STRUCT' | 'CHANGED_STRUCT' | 'CHANGE_STRUCT_DIRTY';

export const changeStruct = (payload: DataStructure | null) =>
  ({
    type: 'CHANGE_DATA_STRUCT',
    payload,
  }) as ReduxBaseAction<DataStructure | null, StructActions>;

export const changeStructIsUpdate = (payload: boolean) =>
  ({
    type: 'CHANGE_STRUCT_IS_UPDATE',
    payload,
  }) as ReduxBaseAction<boolean, StructActions>;

export const clearStruct = () =>
  ({
    type: 'CLEAR_STRUCT',
    payload: void 0,
  }) as ReduxBaseAction<void, StructActions>;

export const changeStructDirty = (payload: boolean) =>
  ({
    type: 'CHANGE_STRUCT_DIRTY',
    payload,
  }) as ReduxBaseAction<boolean, StructActions>;
